<template>
  <div class="wizard-step">
    <slot></slot>
  </div>
</template>

<script>
// Этап мастера stepWizard: мастер показывает только активный этап, а name, title и description - в линии этапов
export default {
  name: "wizardStep",
  props: {
    // Имя этапа для v-model мастера
    name: { type: String, required: true },
    title: { type: String, required: true },
    description: { type: String, default: null },
  },
};
</script>

<style scoped>
.wizard-step {
  height: 100%;
}
</style>
